import React from 'react';
import Layout from '../layout';
import FaqSectionOne from '../components/Esper/FaqSectionOne';
import BlogPosts from '../components/Esper/HomePage/BlogPosts';
import { BottomBanner } from '../components/Esper/BottomBanner';
import Hero from '../assets/v2/group-168.svg';
import { graphql } from 'gatsby';
import messages from '../i18n/en';

class Faq extends React.PureComponent<any, any> {
  public render() {
    return (
      <Layout
        messages={messages}
        ogImage={Hero}
        title={`Esper FAQ's`}
        description={`Answers to FAQ about Esper's Android DevOps cloud. Find answers about Esper for Android devices, our MDM / EMM use cases, and customer support. `}
        keywords={`Android DevOps FAQ's, MDM FAQ, EMM FAQ, Esper FAQ`}
        className="first-page"
        location={this.props.location}
      >
        <FaqSectionOne
          messages={messages}
          query={this.props.data.allContentfulFaq}
        />
        <BottomBanner
          description={
            messages?.FAQPageCTAText ??
            `Find Out Why Esper Is Right For Your Business
          `
          }
          buttonText={messages?.FAQPageCTAButton ?? `Schedule a demo`}
          link={`${
            messages?.locale !== 'en'
              ? `/${messages?.locale}/book-demo/`
              : '/book-demo/'
          }`}
        />
        <BlogPosts />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query {
    allContentfulFaq(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          question
          answer {
            json
            content {
              content {
                value
              }
            }
          }
        }
      }
    }
  }
`;

export default Faq;
